import React from 'react'

import { connect } from 'react-redux';


import { Card, CardBlock, CardTitle , Button , Dropdown , DropdownToggle, 
  DropdownMenu, DropdownItem,Input
} from 'reactstrap';

import ReactTable from "react-table";
import "react-table/react-table.css";

import * as actions from  '../../actions/cotizacion';

import _ from "lodash";

import {API_URL,api}  from '../../actions/_request';
import Menu from '../facturacion/menu.js';


import moment from 'moment';

// import ModalInventario from './inventarioFisicoModal.js'
// import ModalHistoricos from './inventarioFisicoHistoricos.js'
import IconViewTicket from 'react-icons/lib/md/visibility';
import IconEdit from 'react-icons/lib/md/edit';
import IconPrint from 'react-icons/lib/fa/print';
import IconForms from 'react-icons/lib/fa/wpforms';
import IconTimbrar from 'react-icons/lib/fa/check-square-o';
import FaEnvelopeO from 'react-icons/lib/fa/envelope-o';
import IconBan from "react-icons/lib/fa/ban";
import IconsNote  from "react-icons/lib/fa/paperclip";
import IconFileTextO from 'react-icons/lib/fa/file-text-o';
import IconList from 'react-icons/lib/fa/list-alt';

import IconHistorico from 'react-icons/lib/fa/archive';

import swal from 'sweetalert2';
import ModalCorreo from '../../components/cotizaciones/ModalCorreo';
import ModalNota from '../../components/facturarTicket/ModalNota';
import ModalReportes from '../../components/cotizaciones/ModalReportes';

import IconoFactura from '../../images/icons_factura.svg';
import IconoTicket from '../../images/icons_ticket.svg';
import IconoRemision from '../../images/icons_remision.svg';
import ReactSVG from 'react-svg';

const requestData = (pageSize, page, sorted, filtered,filtro) => {    
    return new Promise((resolve, reject) => {
        // You can retrieve your data however you want, in this case, we will just use some local data.
        let filteredData ;


        /* Campos para filtrar */
        var fecha='';
        var cotizacion='';
        var ticket='';
        var factura='';
        var cliente = '';
        /*  */
        var take= pageSize;
        var skip=pageSize * page;
        var total=1;  
        for (var i = filtered.length - 1; i >= 0; i--) {
          switch(filtered[i].id)
          {
            case "fecha":
              fecha=filtered[i].value;
              break;
            case "factura_consecutivo":
              factura=filtered[i].value;
              break;            
           case "cotizacion":
              cotizacion=filtered[i].value;
              break;
           case "ticket":
              ticket=filtered[i].value;
              break;            
            case "cliente":
              cliente=filtered[i].value;
            break;         
          }
        }
        api().get(`/cotizaciones/conteo?fecha=${fecha}&cliente=${cliente}&factura=${factura}&ticket=${ticket}&cotizacion=${cotizacion}&take=${take}&skip=${skip}`)
        .then(function(response)
        {
            if(response.status === 200)
            {
              total= response.data[0].total; 
              api().get(`/cotizaciones/busqueda?fecha=${fecha}&cliente=${cliente}&factura=${factura}&ticket=${ticket}&cotizacion=${cotizacion}&take=${take}&skip=${skip}`)
              .then(function(response)
              {
                if(response.status === 200)
                {
                  filteredData= response.data; 
                  // You can also use the sorting in your request, but again, you are responsible for applying it.
                  const sortedData = _.orderBy(
                    filteredData,
                    sorted.map(sort => {
                      return row => {
                        if (row[sort.id] === null || row[sort.id] === undefined) {
                          return -Infinity;
                        }
                        return typeof row[sort.id] === "string"
                        ? row[sort.id].toLowerCase()
                        : row[sort.id];
                      };
                    }),
                    sorted.map(d => (d.desc ? "desc" : "asc"))
                  );
                  const res = {
                    rows: sortedData,
                    pages: Math.ceil(total / pageSize)
                  };
                  // Here we'll simulate a server response with 500ms of delay.
                  //setTimeout(() => resolve(res), 1000);
                  console.log('data--->',res);
                  resolve(res)
                }
              });   
            }
        });
    });
};

class InvoiceModule extends React.Component{
  constructor(props) {
        super(props);
        this.state = {
            modal       : false,
            prospectoid : null,
            title       : "",
            modalHistoricos : false,
            data: [],
            pages: null,
            loading: true,

            seleccion_id : '',             
            kardexModal : false,
            opcionConsulta : 0,
            modal_reportes:false,
            consulta:0,

            modal_correo:false,
            modal_nota:false,
            factura:0,
            cliente:0,
            filtro:0,
            recargar:true,
        };
        this.toggle       = this.toggle.bind(this);
        this.fetchData = this.fetchData.bind(this);
        


        this.handleChangecheckbox       = this.handleChangecheckbox.bind(this);
        this.toggle_drop       = this.toggle_drop.bind(this);
        this.toggleKardex  = this.toggleKardex.bind(this);
        this.timbrar  = this.timbrar.bind(this);
        this.cancelar  = this.cancelar.bind(this);
        this.toggle_correo  = this.toggle_correo.bind(this);
        this.toggle_nota  = this.toggle_nota.bind(this);
        this.recargar2 = this.recargar2.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.toggle_reportes  = this.toggle_reportes.bind(this);
    }
    procesar(evt,cotizacion,tipo_documento){

      //hacer cambio de leyenda  para cada documento ticket, factura, remision
      let leyenda="Se hara un ticket  para "+cotizacion.cliente+' Por la cantidad de '+cotizacion.total;
      if(tipo_documento==1)
        leyenda="Se hara una Factura  para "+cotizacion.cliente+' Por la cantidad de '+cotizacion.total;
       if(tipo_documento==2)
        leyenda="Se hara una Remision  para "+cotizacion.cliente+' Por la cantidad de '+cotizacion.total;
    
      let self = this;
      let error=false;
      swal.queue([{
        title: 'Estas seguro?',
        text: leyenda,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Estoy Seguro!',
        cancelButtonText: 'Cancelar!',
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return api().post('/procesar/cotizacion/'+cotizacion.value+'/'+tipo_documento)
            .then(function(response)
            {    
                if(response.status === 200)
                {
                  if(response.data.estado){
                     
                     let ticket=response.data.ticket;
                     let opcion =response.data.cotizacion.credito;
                     let cot =response.data.cotizacion;
                     self.props.actualizar_informacion(response.data.cotizacion_tabla);
                     if(tipo_documento==0){
                      self.props.alerta({
                        mensaje:"Se Genero Correctamente El Ticket",
                        tipo:"success",
                        creacion:moment().format('Y-MM-DD H:m:s'),
                      });
                    }
                     if(tipo_documento==1){
                      return api().post('/timbrar_ticket/'+ticket.id+'/'+cot.metodo_pago_codigo+'/'+cot.formas_pago_codigo+'/'+cot.uso_cfdi+'/'+opcion+'/'+cot.plazo_p)
                     }
                     if(tipo_documento==2){
                     return api().post('/remisionar_ticket/'+ticket.id+'/'+opcion)
                     
                     }
                  }else{
                    // console.log('Mensaje de error--->',response.data.mensaje)
                    error=true;
                    swal.insertQueueStep({
                        type: 'error',
                        title: response.data.mensaje
                      })

                   }
                }
            })
            .then(function(response)
            {    
              console.log('segundo then')
                if(tipo_documento>0&& !error)
                if(response.status === 200)
                {   
                   if(response.data.estado){
                    if(tipo_documento==2){
                      self.props.alerta({
                        mensaje:"Cotizacion Remisionada Correctamente",
                        tipo:"success",
                        creacion:moment().format('Y-MM-DD H:m:s'),
                      });
                      return api().post('/actualizar/campo/cotizacion/'+cotizacion.value+'/factura_id/'+response.data.factura.id)
                    }
                    if(tipo_documento==1){
                      if(!response.data.vencidas){
                         self.props.alerta({
                          mensaje:"Cotizacion Remisionada Correctamente",
                          tipo:"error",
                          creacion:moment().format('Y-MM-DD H:m:s'),
                        });
                         return api().post('/actualizar/campo/cotizacion/'+cotizacion.value+'/factura_id/'+response.data.factura.id)
                        }else{
                          self.props.alerta({
                            mensaje:"Cotizacion Facturada Correctamente",
                            tipo:"success",
                            creacion:moment().format('Y-MM-DD H:m:s'),
                          });
                          return api().post('/actualizar/campo/cotizacion/'+cotizacion.value+'/factura_id/'+response.data.factura.id)
                        }
                    }
                    if(tipo_documento==0){
                      self.props.alerta({
                        mensaje:"Se Genero Correctamente El Ticket",
                        tipo:"success",
                        creacion:moment().format('Y-MM-DD H:m:s'),
                      });
                    }
                   }else{
                    swal.insertQueueStep({
                        type: 'error',
                        title: response.data.mensaje
                      })
                   }
                }
            })
            .then(function(response)
            {    console.log('tercer then')
                if(tipo_documento>0&& !error)
                  if(response.status === 200)
                  {   
                     self.props.actualizar_informacion(response.data.cotizacion);
                  }
            })
            .catch(() => {
              swal.insertQueueStep({
                type: 'error',
                title: 'Solicitar ayuda a un Administrador',
              })
            })
        }
      }])//Fin del SWAL


    }

    handleSelectChange(select, name,tipo=0) {;
      let value=null;
        if(tipo==0){
           value = select === null ? null : select.target.value;
        }else{
           value = select === null ? null : select.value;
        }
     
        this.setState({[name] : value,
                        recargar:false,
                        data:[],
                      });

    }
     recargar2(){
        this.setState({
          recargar:true,
      });
    }
    toggle_nota(evt,factura=[]){ 
        // evt.preventDefault();
         console.log('factura--->',factura);
        this.setState({
              modal_nota : !this.state.modal_nota, 
              factura : factura,
          });
    }
    toggle_correo(evt=[],factura=[]){ 

        // console.log('factura--->',factura);
        this.setState({
              modal_correo : !this.state.modal_correo, 
              factura : factura.value,
              cliente : factura.cliente_id,
          });
    }
    toggle_reportes(evt,consulta=0){ 

        // console.log('factura--->',factura);
        this.setState({
              modal_reportes : !this.state.modal_reportes, 
              consulta:consulta,
          });
    }
     cancelar(evt, factura){
      // console.log('Factura------>',factura)
      let self = this;
      swal.queue([{
        title: 'Estas seguro?',
        text: "Se Cacelara la factura "+factura.factura+" para "+factura.cliente+' Por la cantidad de '+factura.total,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Estoy Seguro!',
        cancelButtonText: 'Cancelar!',
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return api().get('/cancelar_factura/'+factura.value)
            .then(function(response)
            {    
                // console.log('response-->',response)    
                if(response.status === 200)
                {
                  // console.log('entor al status 200');
                  // console.log('factura-->',response.data.factura) ;
                  if(parseInt(response.data.estado)==200){
                     self.props.timbrar(response.data.factura);
                  }
                   if(parseInt(response.data.estado)==210){
                     swal.insertQueueStep({
                      type: 'error',
                      title: 'La Factura Cuenta Con Abonos'
                    })
                  }
                  if(parseInt(response.data.estado)==500){
                    console.log('Mensaje de error--->',response.data.error.descripcion)
                    swal.insertQueueStep({
                        type: 'error',
                        title: response.data.error.descripcion
                      })

                   }
                 
                }
            })
            .catch(() => {
              swal.insertQueueStep({
                type: 'error',
                title: 'Solicitar ayuda a un Administrador',
              })
            })
        }
      }])
    }
    cancelar_sin_timbrar(evt, factura){
      // console.log('Factura------>',factura)
      let self = this;
      swal.queue([{
        title: 'Estas seguro?',
        text: "Se Cacelara el Documento "+factura.factura+" para "+factura.cliente+' Por la cantidad de '+factura.total,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Estoy Seguro!',
        cancelButtonText: 'Cancelar!',
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return api().get('/cancelar_sin_timbrar/'+factura.value)
            .then(function(response)
            {    
                // console.log('response-->',response)    
                if(response.status === 200)
                {
                  // console.log('entor al status 200');
                  // console.log('factura-->',response.data.factura) ;
                  if(parseInt(response.data.estado)==200){
                     self.props.timbrar(response.data.factura);
                  }
                   if(parseInt(response.data.estado)==210){
                     swal.insertQueueStep({
                      type: 'error',
                      title: 'el Documento Cuenta Con Abonos'
                    })
                  }
                 
                }
            })
            .catch(() => {
              swal.insertQueueStep({
                type: 'error',
                title: 'Solicitar ayuda a un Administrador'
              })
            })
        }
      }])
    }
    timbrar(evt, factura){
      // console.log('Factura------>',factura)
      let self = this;
      swal.queue([{
        title: 'Estas seguro?',
        text: "Se Timbrara la factura para "+factura.cliente+' Por la cantidad de '+factura.total,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Estoy Seguro!',
        cancelButtonText: 'Cancelar!',
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return api().get('/timbrar_factura/'+factura.value+'/I')
            .then(function(response)
            {    
                // console.log('response-->',response)    
                if(response.status === 200)
                {
                  

                  if(parseInt(response.data.estado)==200){
                    
                    self.props.timbrar(response.data.factura);
                    
                    window.open(API_URL+'/pdf_factura/'+factura.value+'/I');

                    if(!response.data.vencidas){
                          swal.insertQueueStep({
                        type: 'error',
                        title: 'Se Timbro con Exito la factura , pero el cliente cuenta con Facturas vencidad'
                      })
                    }



                  }else{
                    console.log('Mensaje de error--->',response.data.mensaje)
                    swal.insertQueueStep({
                        type: 'error',
                        title: response.data.mensaje
                      })

                   }
                }
            })
            .catch(() => {
              swal.insertQueueStep({
                type: 'error',
                title: 'Solicitar ayuda a un Administrador'
              })
            })
        }
      }])
    }



  toggle_drop(menu,id) {
    let valor=0;

    if(menu===1){
      if(parseInt(this.state.menu)!==id)
        valor=id;
        this.setState({
          menu: valor
        });
    }else{
      if(parseInt(this.state.submenu)!==id)
        valor=id;
        this.setState({
          submenu: valor
        });
    }
  }

  handleChangecheckbox(row)
  {
    let bandera=0;
    this.setState({
      seleccion_id : parseInt( row.original.value),
      seleccion_label : row.original.label,
    });  
  }


  toggleKardex(evt, opcion, title = "")
    {
        let {modal_reportes} = this.state;
        let {consulta} = this.state;

        consulta = opcion;
        switch(parseInt (opcion)){
         
           default: 
             this.setState({
                  modal_reportes       : !modal_reportes,
                  title       : title,
                  consulta : consulta
              });
           break;

        }
        
     
    }



   

    fetchData(state, instance) {
    // Whenever the table model changes, or the user sorts or changes pages, this method gets called and passed the current table model.
    // You can set the `loading` prop of the table to true to use the built-in one or show you're own loading bar if you want.
    this.setState({ loading: true });
    // Request the data however you want.  Here, we'll use our mocked service we created earlier
    requestData(
      state.pageSize,
      state.page,
      state.sorted,
      state.filtered,
      this.state.filtro,
    ).then(res => {
      // Now just get the rows of data to your React Table (and update anything else like total pages or loading)
      this.setState({
        data: res.rows,
        pages: res.pages,
        loading: false
      });
      console.log('rows----->',res.rows)
      this.props.get(res.rows);
    });
  }

  toggle(evt, prospectoid = null, title = "Agregar Inventario Fisico")
    {
        let {modal} = this.state;

        this.setState({
            modal       : !modal,
            prospectoid : prospectoid,
            title       : title,
            
        });
    }
   

    render(){
      let permisos_modulos= this.props.auth.permisos[6];
      // console.log('permisos--->',permisos_modulos);
      
      const { data, pages, loading ,recargar} = this.state;
      // console.log(this.props.inventarioFisico.data)
      if(recargar==false)
          setTimeout(this.recargar2() , 3);
      return(

        <div className="view">
              <Menu props={this.props}/>
                <div className="view-header">
                    <header className="title text-white">
                        <h1 className="h4 text-uppercase">Lista de Cotizaciones </h1>
                    </header>
                </div>
              <div className="view-content view-components">
                    <Card>
                        <CardBlock>

                          <div className="text-right">
                          <div className="row">
                          <div className="col-md-3 text-left">
                            <Dropdown nav className='btn-sm info' color="" isOpen={parseInt(this.state.menu)===1?true:false} toggle={() => {this.toggle_drop(1,1);}} >
                              <DropdownToggle nav caret>
                               <IconForms/>Consultas
                              </DropdownToggle>
                              <DropdownMenu className='letras_menu'>
                                <DropdownItem onClick={(e) => this.toggleKardex(e,1,'Seguimiento de Cotizaciones')}>Seguimiento de Cotizaciones</DropdownItem>
                                
                              </DropdownMenu>
                            </Dropdown>
                          </div>
                        <div className="col-md-6"> 
                                   
                        </div>

                        <div className="col-md-3"> 
                          <div className="form-group">
                            {' '}
                            <Button color="success" className="mb-2" onClick={() => { this.props.history.push('/cotizaciones/form');}}>
                              {<IconList/>}&nbsp;Agregar
                            </Button>
                          </div>
                        </div>
                    </div>
                          </div>
                           {(recargar==true)&& <ReactTable
                              getTrProps={(state, rowInfo, column) => {
                                  
                                  if(rowInfo === undefined){
                                         
                                    return{
                                      }
                                    } else{
                                      return{
                                        onDoubleClick: (e) => {
                                          console.log('variable---->',rowInfo.original.timbrado)
                                          if(parseInt(rowInfo.original.timbrado)==0){
                                            this.props.history.push('/cotizaciones/edit/'+rowInfo.original.value);
                                          }else{
                                            swal('', 'La Cotizacion no se puede editar  ya fue aprobada  ');              
                                          }
                                        }
                                      }
                                    }
                              }}
                              className = "-striped -highlight"
                              columns   = {[
                                 {
                                    Header: 'Seleccion',
                                    filterable: false,
                                    sortable: false,
                                    maxWidth:80,
                                    minWidth:80, 
                                    Cell: (row) =>
                                    {
                                        return(
                                            <div className="text-center">
                                                <input type="checkbox"
                                                name="" 
                                                checked={(this.state.seleccion_id === parseInt( row.original.value)) ? true : false}
                                                onChange={() => this.handleChangecheckbox(row)}/>                                                 
                                            </div>
                                        )
                                    }
                                },{
                                    Header: 'Controles',
                                    filterable: false,
                                    sortable: false,
                                    minWidth:290,
                                    maxWidth:290,
                                    Cell: (row) =>
                                    {
                                        return(
                                            <div className="text-right">
                                            <Button color={parseInt(row.original.enviada)==1?"info":"secondary"}
                                             title=" Enviar Cotizacion"
                                             onClick={(evt)=>this.toggle_correo(evt, row.original)}>
                                              <FaEnvelopeO />
                                            </Button>
                                              {' '}
                                                 {
                                                  <a href={API_URL+"/pdf_cotizacion/"+row.original.value} target="_blank">
                                                      <Button color="secondary" title=" Imprimir Cotizacion" >
                                                          <IconPrint  />
                                                      </Button>
                                                  </a>
                                                }
                                                {' '}
                                                {
                                                  (parseInt(row.original.timbrado)==0&&parseInt(row.original.cancelado)==0)&&
                                                <Button
                                                 color="success" 
                                                 title=" Editar Documento"
                                                 onClick={(evt)=>this.props.history.push('/cotizaciones/edit/'+row.original.value)}>
                                                    <IconEdit />
                                                </Button> 

                                              }
                                            
                                              {' '}
                                              {
                                                  (parseInt(row.original.timbrado)==0&&parseInt(row.original.cancelado)==0&&parseInt(row.original.vencida)==0)&&
                                              <Button color="warning" className='boton_svg' title="Ticket" onClick={(evt)=>this.procesar(evt, row.original,0)}>
                                                <ReactSVG src={IconoTicket}  beforeInjection={svg => { svg.classList.add('svg-class-name'); svg.setAttribute('style', 'width: 17px; fill:white;') }}/>
                                              </Button>
                                              }{' '}{
                                                  (parseInt(row.original.timbrado)==0&&parseInt(row.original.cancelado)==0&&parseInt(row.original.vencida)==0)&&
                                              
                                              <Button color="info" className='boton_svg' title="Factura" onClick={(evt)=>this.procesar(evt, row.original,1)}>
                                                <ReactSVG src={IconoFactura}  beforeInjection={svg => { svg.classList.add('svg-class-name'); svg.setAttribute('style', 'width: 17px; fill:white;') }}/>
                                              </Button>
                                              }{' '}{
                                                  (parseInt(row.original.timbrado)==0&&parseInt(row.original.cancelado)==0&&parseInt(row.original.vencida)==0)&&
                                              
                                              <Button color="success" className='boton_svg' title="Remision" onClick={(evt)=>this.procesar(evt, row.original,2)}>
                                               <ReactSVG src={IconoRemision}  beforeInjection={svg => { svg.classList.add('svg-class-name'); svg.setAttribute('style', 'width: 17px; fill:white;') }}/>
                                              </Button>
                                            }
                                            {' '}
                                                {
                                                  (parseInt(row.original.ticket_id)>0)&&
                                                <Button
                                                 color="success" 
                                                 title=" Visualizar Ticket"
                                                 onClick={(evt)=>this.props.history.push('/tickets/ver/'+row.original.ticket_id)}>
                                                    <IconViewTicket />
                                                </Button> 

                                              }{' '}



                                            {
                                                  (parseInt(row.original.factura_timbrada)==1&&parseInt(row.original.factura_doc)==1)&&
                                                   <a href={API_URL+"/pdf_factura/"+row.original.factura_id+'/I'} target="_blank">
                                                      <Button color="info" title=" Imprimir Factura" >
                                                          <IconPrint  />
                                                      </Button>
                                                  </a>
                                              }{' '}{
                                                  (parseInt(row.original.factura_timbrada)==1&&parseInt(row.original.factura_doc)==2)&&
                                                  <a href={API_URL+"/pdf_remision/"+row.original.factura_id} target="_blank">
                                                      <Button color="success" title=" Imprimir Remision" >
                                                          <IconPrint  />
                                                      </Button>
                                                  </a>
                                            }
                                              
                                            </div>
                                        )
                                    }
                                },
                                {Header: 'Cotizacion', accessor: 'cotizacion',maxWidth:150,minWidth:150 , style: { 'textAlign': 'center'}},
                                {Header: 'Ticket', accessor: 'ticket',maxWidth:150,minWidth:150 , style: { 'textAlign': 'center'}},
                                {Header: 'Factura/Rem', accessor: 'factura_consecutivo',maxWidth:150,minWidth:150 , style: { 'textAlign': 'center'}},
                                {Header: 'Fecha', accessor: 'fecha',maxWidth:150,minWidth:150 , style: { 'textAlign': 'center'}},
                                {Header: 'Cliente', accessor: 'cliente', minWidth:210,},
                                {Header: 'Total', accessor: 'total',maxWidth:150,minWidth:150 , filterable: false, sortable: false, style: { 'textAlign': 'center'}},
                                
                                
                              
                              ]}
                            
                              manual // Forces table not to paginate or sort automatically, so we can handle it server-side
                              data={this.props.cotizacion.data}
                              pages={pages} // Display the total number of pages
                              loading={loading} // Display the loading overlay when we need it
                              onFetchData={_.debounce(this.fetchData, 500)} // Request new data when things change
                              filterable
                              defaultPageSize={10} 
                              SubComponent={ row => {
                                return(
                                    <Card>
                                        <CardBlock>
                                            <CardTitle className="h6 text-uppercase mb-4">Más Información</CardTitle>
                                            {
                                              false&&
                                              <div className='row'>
                                              <div className='col-12'>
                                                <h1 className="h4 text-uppercase">Nota:</h1>
                                              </div>
                                              <div className='col-12'>
                                                <p className=" text-uppercase">{row.original.nota_interna} </p>
                                              </div>
                                            </div> 
                                            }
                                            
                                            <table className="table">
                                              <thead>
                                                <tr>
                                                  <th>Codigo</th>
                                                  <th>Descripción</th> 
                                                  <th>Cantidad</th>
                                                  <th>Total</th>                                                 
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {
                                                  row.original.productos.map((item, i) => 
                                                  <tr key={i}>
                                                   <td>{item.codigo_item}</td>
                                                   <td>{item.descripcion_item}</td>
                                                   <td>{item.cantidad}</td>
                                                   <td>{item.total}</td>  
                                                  </tr>)
                                                }
                                              </tbody>
                                            </table>
                                        </CardBlock>
                                    </Card>
                                )
                              }}
                             
                            />
                          }
                        </CardBlock>
                    </Card>
                </div>
                { this.state.modal_correo&&
                    <ModalCorreo
                        open={this.state.modal_correo}
                        toggle={this.toggle_correo}  
                        cliente={this.state.cliente} 
                        factura={this.state.factura}
                    />
                }
                { this.state.modal_nota&&
                    <ModalNota
                        open={this.state.modal_nota}
                        toggle={this.toggle_nota}  
                        documento={this.state.factura}
                    />
                }
                {
                   this.state.modal_reportes&& 
                   <ModalReportes 
                 open={this.state.modal_reportes} 
                 toggle={this.toggle_reportes} 
                 title={this.state.title} 
                 consulta={this.state.consulta}
                />
                }
             
              
            </div>

      )
    }
}

function mapStateToProps(state, ownProps) {
    return {
        cotizacion : state.cotizacion,
        auth:state.auth,
    }
};
export default connect(mapStateToProps, actions)(InvoiceModule)


// WEBPACK FOOTER //
// ./src/views/cotizaciones/tabla.js